// =============================================================================
// Troubleshooting accordion (design feedback: every row collapsed by default).
// One row open at a time; without JS every row stays expanded.
// =============================================================================

function init() {
	document.querySelectorAll(".aa-troubleshoot").forEach((list) => {
		const cards = Array.from(list.querySelectorAll(".aa-troubleshoot__card"));
		if (!cards.length) return;

		const set = (card, open) => {
			card.classList.toggle("is-open", open);
			const btn = card.querySelector(".aa-troubleshoot__title");
			if (btn) btn.setAttribute("aria-expanded", open ? "true" : "false");
		};

		list.classList.add("is-accordion");
		cards.forEach((card) => set(card, false));

		cards.forEach((card) => {
			const btn = card.querySelector(".aa-troubleshoot__title");
			if (!btn) return;
			btn.addEventListener("click", () => {
				const wasOpen = card.classList.contains("is-open");
				cards.forEach((c) => set(c, false));
				if (!wasOpen) set(card, true);
			});
		});
	});
}

if ("loading" === document.readyState) {
	document.addEventListener("DOMContentLoaded", init);
} else {
	init();
}
